import { render } from "./contractRegister.vue?vue&type=template&id=2247cd10&scoped=true"
import script from "./contractRegister.vue?vue&type=script&lang=js"
export * from "./contractRegister.vue?vue&type=script&lang=js"

import "./contractRegister.vue?vue&type=style&index=0&id=2247cd10&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2247cd10"]])

export default __exports__